<template>
    <div class="mt-5">
        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <h3>
                    <slot name="title"></slot>
                </h3>
                <p>
                    <slot name="description"></slot>
                </p>
            </div>
            <div class="md:col-span-2">
                <div class="bg-white overflow-hidden shadow sm:rounded-lg p-2" scroll-region>
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSection',
};
</script>
